import { Theme } from '../../../config/theme';

export const defaultOptions = {
  layoutOptions: {
    layout: undefined, //overrides all other layoutOptions
    columns: 10,
    pyramid: false, //each row one column less
    symbolsColumns: 8, //if undefined copy from normal layout
    symbolsPyramid: undefined, //if undefined copy from normal layout
    letters: 'qwerty',
    capsButton: true,
    numberPad: true, //include numpad button
    symbolPad: true, //include symbol button
    noSpacebar: false, //leave out spacebar
    noFinished: false,
    emailMode: false,
  },

  styling: {
    align: 'left',
    horizontalSpacing: 0,
    verticalSpacing: 0,
  },

  keyOptions: {
    buttonTypes: undefined, // overrides all other options
    w: 100,
    h: 50,
    label: {
      fontSize: 30,
      ...Theme.Fonts.Default,
      fontFace: 'Regular',
      fontFamily: 'Regular',
      //basically any setter you can use when using a text texture
    },
    backgroundColors: {
      ...Theme.Colors.Keyboard.Background,
    },
    labelColors: {
      ...Theme.Colors.Keyboard.Text,
    },
  },
  Layout: {}, //options for specific kinds of keys
  Space: { w: 200 },
  Clear: {},
  Backspace: {},
};
